import { createConnection, Connection, ConnectionOptions, Repository, EntityManager, getConnection } from 'typeorm';
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { CordovaConnectionOptions } from 'typeorm/driver/cordova/CordovaConnectionOptions';
import { WebSqlConnectionOptions } from 'typeorm/driver/websql/WebSqlConnectionOptions';
import { LoggerOptions } from 'typeorm/logger/LoggerOptions';
import { Config } from '../entities/config';

const entities = [
    Config,
];

@Injectable()
export class Database {

    private connection: Connection;
    private connectionOptions: ConnectionOptions;
    private initialised: boolean = false;

    constructor(
        private platform: Platform,
    ) {}

    /**
     * @returns {Promise<Connection>}
     */
    async init(): Promise<Connection> {
        return this.platform.ready().then(async () => {

            this.connectionOptions = Database.isDevice() ? Database.cordovaConnectionOptions() : Database.webSqlConnectionOptions();

            try {
                this.connection = getConnection();
            } catch (e) {
                this.connection = await createConnection(this.connectionOptions);
            }
            if (this.connection) this.initialised = true;

            try {
                await this.connection.synchronize();
            } catch (error) {
                // if (!Database.isDevice()) console.log(error);
                // else console.error(error);
            }

            return this.connection;
        });
    }

    get isInitialised(): boolean {
        return this.initialised;
    }

    /**
     * @returns {SqliteConnectionOptions}
     */
    static cordovaConnectionOptions(): CordovaConnectionOptions {
        return {
            database: 'derrybros',
            entities: entities,
            logging: Database.loggerOptions(),
            location: 'default',
            type: 'cordova',
        };
    }

    /**
     * @returns {WebSqlConnectionOptions}
     */
    static webSqlConnectionOptions(): WebSqlConnectionOptions {
        return {
            database: 'derrybros',
            description: 'Derry Bros',
            entities: entities,
            logging: Database.loggerOptions(),
            size: 5 * 1024 * 1024,
            type: 'websql',
            version: '1.0',
        };
    }

    /**
     * @returns { LoggerOptions }
     */
    static loggerOptions(): LoggerOptions {
        return false;
        // return true;
        // return 'all';
        // return ['info','log'];
        // return ['error','log'];
        // return ['error','info','log'];
        // return ['query','schema','migration'];
        // return ['query','schema','error','warn','info','log','migration'];
    }

    /**
     * @returns {boolean}
     */
    private static isDevice(): boolean {
        if (typeof window['device'] === 'undefined') return false;
        return window['device'].platform !== 'windows';
    }

    /**
     * @returns {EntityManager}
     */
    entityManager(): EntityManager {
        return this.connection.createEntityManager();
    }

    /**
     * @param {string} queryString
     * @param {any[]} parameters
     * @returns {any}
     */
    query(queryString: string, parameters?: any[]): any {
        return this.entityManager().query(queryString, parameters);
    }

    /**
     * @returns {Repository<Config>}
     */
    config(): Repository<Config> {
        return this.connection.getRepository('config');
    }

}



// WEBPACK FOOTER //
// ./src/providers/database.ts